import {
  Router,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  NavigationEnd,
} from '@angular/router';
import {
  Component,
  Compiler,
  ViewChild,
  ElementRef,
  OnInit,
} from "@angular/core";
import swal from "sweetalert2";
import * as moment from "moment/moment";

import { AppService } from "./_services/app.service";
import { ConfigService } from "./_services/config.service";
import { GrupoEconomicoService } from "./_services/grupo-economico.service";
import { AuthenticationService } from "./_services/authentication.service";

import { GrupoEconomico } from "app/_models/grupo-economico";
import { GrupoEconomicoRequest } from "./_models/grupo-economico-request";
import { FilterComboConfiguration } from "./_models/filterComboConfiguration";
import { AnalyticsService } from "app/_services/analytics.service";
import { AnalyticsTela } from "./_enums/analytics-tela";
import { AnalyticsOperacao } from "./_enums/analytics-operacao";
import { GoogleConfig } from "./_models/google-config";
import { LoginForgeRockService } from "./_services/login-forgerock.service";
import { Login } from "./_models/login";
import { BaseService } from "./_services/base.service";
import { catchError } from "rxjs/operators";
import { VersionService } from "./_services/version.services";
import {MedalliaService} from './_services/medallia.service';
import {MopService} from './mop.service';
import {CookiesConsentService} from './_services/cookies-consent.service';
import { LaunchDarklyService } from './_services/launch-darkly.service';
import { ForgeRockTokenService } from './_services/forge-rock-token.service';

declare var ocultarControleMenu: any;
declare var ocultarSwalOverlay: any;
declare var removeSwal: any;
declare var isIe: boolean;
declare var loadMaps: any;
declare var loadAnalytics: any;
declare var browser_versao: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  @ViewChild("closeModal", { static: true }) private closeModal: ElementRef;
  comboGrupoEconomico: FilterComboConfiguration;
  mensagemErro: string;
  username: string = "";
  logado: boolean = false;
  loadingGrupos: boolean = false;
  grupos: GrupoEconomico[] = [];
  gruposSelecionados: number[];
  labelGrupo: string;
  cssClassAdmin = "";
  loadingRouter: boolean = true;
  error = "";
  dropdownVisibleMenuLogin = false;
  dropdownVisibleMenuRegister = false;
  hideTimeout: any;
  isDropdownOpen: boolean = false;
  shouldShowCookiesConsent = false
  public login: Login = new Login();
  maintenanceBannerType: Record<string, string> = {
    info: 'info',
    warn: 'warn',
    error: 'error',
    none: 'none'
  }
  showMaintenanceBanner: boolean = false;
  maintenanceBannerTypeValue: string = 'none';
  maintenanceBannerMessage: string = '';
  currentVersion: string = "";
  currentEnv: string = "";

  constructor(
    public _router: Router,
    public _authenticationService: AuthenticationService,
    public _appService: AppService,
    private _compiler: Compiler,
    private _configService: ConfigService,
    private _grupoService: GrupoEconomicoService,
    private _loginForgeRockService: LoginForgeRockService,
    private _baseService: BaseService,
    private _analyticsService: AnalyticsService,
    private _versionService: VersionService,
    private medalliaService: MedalliaService,
    private _mopService: MopService,
    private _cookiesConsent: CookiesConsentService,
    private _launchDarklyService: LaunchDarklyService,
    private _forgeRockTokenService: ForgeRockTokenService
  ) {
    performance.mark('app_initial_load_start');
    _loginForgeRockService.SetConfig(_configService);

    this._compiler.clearCache();

    Date.prototype.toJSON = function () {
      return moment(this).format();
    };

    this.loadGoogleConfig(_configService._googleConfig);
    this._appService.configInfo = _configService._config;
    this._appService.apiUrl = this._appService.configInfo.apiUrl;
    localStorage.setItem("browser_versao", JSON.stringify(browser_versao));
    localStorage.setItem("apiUrl", JSON.stringify(_configService._config));
    this._mopService.initializeTelemetry()
    this.PopularUsuario();

    this._authenticationService.emitirLogin.subscribe((modal) => {
      this.PopularUsuario();
    });

    this._appService.emitirLogin.subscribe((modal) => {
      this.PopularUsuario();
      if (modal) {
        this._appService.limpaStorage();
      }
    });

    this._appService.emitirLogout.subscribe((value) => {
      swal({
        title: "Alerta",
        text: "Sua sessão expirou. Faça o login novamente para prosseguir.",
        type: "warning",
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: "OK",
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        this._router.navigate(["/"]);
        localStorage.removeItem("dataExpiracaoSessa");
        this._authenticationService.logout(value);
        this._loginForgeRockService.logout();
        this._mopService.resetUser()
      });
    });

    this.loadingRouter = true;

    setTimeout(() => {
      this.verificaLoginForgeRockEfetivado();
    }, 3000);

    this.comboGrupoEconomico = new FilterComboConfiguration(
      "Grupo(s) Econômico(s)..."
    );
    this.comboGrupoEconomico.settings = {
      checkedStyle: "glyphicon",
      showCheckAll: false,
      showUncheckAll: true,
      dynamicTitleMaxItems: 0,
      enableSearch: true,
    };

    if (isIe) {
      removeSwal();

      swal({
        title: "Atenção",
        text: "Este site é melhor visualizado no navegador Google Chrome",
        type: "warning",
      }).then(
        () => {
          ocultarControleMenu();
          ocultarSwalOverlay();
        },
        () => {
          removeSwal();
        }
      );
    }

    if(this._configService._version) {
      this.currentVersion = this._configService._version;
      this.currentEnv = this._configService._config.nomeAmbiente;
    }

    if(this._configService._config.ldClientId) {
      this._launchDarklyService.flags$.subscribe(flags => {
        console.log('Flags atualizadas no AppComponent:', flags)
        this.showMaintenanceBanner = flags['maintenance-mode-pcab2-enabled'];
        this.maintenanceBannerTypeValue = flags['maintenance-banner-type'];
        this.maintenanceBannerMessage = flags['maintenance-message'] ?? 'We may have performance issues during this period. We apologize for the inconvenience and appreciate your understanding.';
      });
    }
  }

  toggleDropdown(): void {
    if (!this.logado) {
      // Só alterna o dropdown se não estiver logado
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }

  showDropdownMenuLogin() {
    this.dropdownVisibleMenuLogin = true;
  }

  showDropdownMenuRegister() {
    this.dropdownVisibleMenuRegister = true;
  }

  showDropdownMenuMobile(menu: string) {
    this[menu] = !this[menu];
  }

  scheduleHideDropdownMenuLogin() {
    this.hideTimeout = setTimeout(() => {
      this.dropdownVisibleMenuLogin = false;
    }, 300); // Pequeno delay para evitar fechamento inesperado
  }

  scheduleHideDropdownMenuRegister() {
    this.hideTimeout = setTimeout(() => {
      this.dropdownVisibleMenuRegister = false;
    }, 300); // Pequeno delay para evitar fechamento inesperado
  }

  cancelHideDropdown() {
    clearTimeout(this.hideTimeout);
  }

  private async verificaLoginForgeRockEfetivado() {
    try {
      const locationSearch = window.location.search;
      const searchParams = String(locationSearch)
        .substring(1, locationSearch?.length)
        .split(`&`);
      let queryParams: string[] = [];
      searchParams?.map((search) => {
        if (search.includes(`code=`)) queryParams.push(`code`);
        if (search.includes(`iss=`)) queryParams.push(`iss`);
        if (search.includes(`client_id=`)) queryParams.push(`client_id`);
      });

      if (
        queryParams.includes(`code`) &&
        queryParams.includes(`iss`) &&
        queryParams.includes(`client_id`)
      ) {
        const retorno = await this._loginForgeRockService.getTokenRaw();
        // nova posição do login start time para métrica - após a autenticação do forgerock
        performance.mark('login_time_start');
        if (retorno) this.efetuaLogin(retorno);

      } else {
        this.loadingRouter = false;
        performance.mark('app_initial_load_end');
        performance.measure('app_initial_load', 'app_initial_load_start', 'app_initial_load_end');
      }
    } catch (e) {
      if (e.message === 'MaxTokenAttemptsReached') {
        this._mopService.faro.api.pushError({
          name: 'MaxTokenAttemptsReached',
          message: 'Número máximo de tentativas de obtenção do token atingido'
        })
      }
      this._loginForgeRockService.limpaStorage()
    }
  }

  async checkCookies() {
    const user = this._appService.UsuarioLogado

    if (user) {
      this._cookiesConsent.getDataByUserId(user.usuarioID, user.email).subscribe(data => {
        this.medalliaService.updateOptInValue(data.optIn)
        this.shouldShowCookiesConsent = data.displayConsent
      })
    }
  }

  efetuaLogin(retorno) {
    this._authenticationService
      .LoginForgeRock(retorno)
      .pipe(
        catchError((error) => {
          this.loadingRouter = false;
          this.logado = false;
          swal({
            title: "Erro Login!",
            text: "Não foi possível realizar o seu login! Tente novamente mais tarde!",
            type: "warning",
            confirmButtonText: "Ok",
            showConfirmButton: true,
          });
          localStorage.removeItem("dataExpiracaoSessao");
          this._baseService.limpaStorage();
          this._loginForgeRockService.limpaStorage();

          this._router.navigate(["/"]);

          throw error;
        })
      )
      .subscribe((result) => {
        this.error = "";
        if (result.IsValid) {
          this.logado = true;
          this.login = new Login();
          let usuario = this._appService.UsuarioLogado;
          this.logado = true;

          this.PopularUsuario();
          this.checkCookies();

          let descricaoPerfis = [
            "Cliente Master",
            "Cliente Tracking",
            "Cliente Booking e Rastreamento",
            "Cliente Financeiro Operacional",
          ];

          if (
            descricaoPerfis.some(
              (perfil) => perfil === usuario.perfil.descricao
            )
          )
            this._router.navigate(["/rastreamento"]);
          else {
            this._router.navigate(["/home"]);
            // setTimeout(() => {
            //   window.location.reload();
            // }, 200);
          }
          performance.mark('login_time_end');
          performance.measure('login_time', 'login_time_start', 'login_time_end');
          this._appService.tokenExpirado = false;
          this.loadingRouter = false;
        } else {
          this.error =
            result.Erros[0].ErrorCode + " " + result.Erros[0].Message;
          this._appService.tokenExpirado = true;
          this.loadingRouter = false;
          this.logado = false;

          var erroMsg =
            'Não conseguimos identificar seu acesso. Por gentileza, contate <a href="mailto:suportecomercial@alianca.com.br">suportecomercial@alianca.com.br</a>';

          var tituloErro = "Não identificamos seu acesso";

          if (result.Erros[0].Message.includes("não autorizado")) {
            tituloErro = "Usuário não autorizado!";
            erroMsg = result.Erros[0].Message;

            swal({
              title: tituloErro,
              text: erroMsg,
              type: "warning",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: "OK",
            }).then(
              (success) => {
                this._baseService.limpaStorage();
                this.redirectToRegisterForge();

                ocultarControleMenu();
                ocultarSwalOverlay();
              },
              (dismiss) => {
                removeSwal();
              }
            );
          } else {
            swal({
              title: tituloErro,
              html: erroMsg,
              type: "question",
              showCancelButton: false,
              confirmButtonText: "OK",
            }).then(
              (success) => {
                // this._baseService.limpaStorage();
                // this.redirectToRegisterForge();

                // ocultarControleMenu();
                // ocultarSwalOverlay();
                removeSwal();
              },
              (dismiss) => {
                removeSwal();
              }
            );
          }
        }
      });
  }

  private loadGoogleConfig(cfgGoogle: GoogleConfig) {
    var cfgAnalytics = cfgGoogle.Analytics;
    this._appService.configAnalytics = cfgAnalytics;
    this._appService.configMaps = cfgGoogle.Maps;
    //localStorage.setItem('google-config', JSON.stringify(cfgGoogle));
    loadMaps(cfgGoogle.Maps.ApiKey);

    if (cfgAnalytics.Habilitado) loadAnalytics(cfgAnalytics.GtagID);
  }

  ngOnInit(): void {
    this._versionService.checkVersion2();

    this.labelGrupo = this._appService.getLocalStorage("labelGrupo");
    if (this.labelGrupo) this.gruposSelecionados = this.getGrupoStorage();

    let eAdmin = this._appService.isAdmin();
    this.cssClassAdmin = eAdmin ? "peril-admin" : "";
    this.medalliaService.clearVariables()
    this.checkCookies()
    this._router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouter = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouter = false;
      } else if (event instanceof NavigationEnd) {

      }
    });
  }

  PopularUsuario(): void {
    if (this._appService.UsuarioLogado != null) {
      this._mopService.setUser(this._appService.UsuarioLogado.usuarioID.toString(), this._appService.UsuarioLogado.nome)
      this.username = this._appService.UsuarioLogado.nome;
      this.logado = true;
      this._analyticsService.RegistrarOperacao(
        AnalyticsTela.Home,
        AnalyticsOperacao.LoginRealizado
      );
    } else {
      this.username = "";
      this.logado = false;
      this.labelGrupo = "";
    }
  }

  public redirectToLoginForge(): void {
    if (this._forgeRockTokenService.hasAccessToken()) {
      this._loginForgeRockService.logout();
    } else {
      this._loginForgeRockService.loginRedirect();
    }
  }

  public logout(): void {
    removeSwal();

    swal({
      title: "Sair",
      text: "Deseja realmente sair do sistema?",
      type: "question",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then(
      (success) => {
        this.labelGrupo = "";
        this.gruposSelecionados = [];
        this._authenticationService.logout();
        this._appService.tokenExpirado = false;
        this._loginForgeRockService.logout();
        this._router.navigate(["/home"]);
        this.medalliaService.clearVariables()
        this._mopService.resetUser()
        ocultarControleMenu();
        ocultarSwalOverlay();
      },
      (dismiss) => {
        removeSwal();
      }
    );
  }

  ObterGrupos() {
    if (!this._appService.UsuarioLogado || this.grupos.length > 0) return;

    this.loadingGrupos = true;
    var request: GrupoEconomicoRequest = new GrupoEconomicoRequest();
    request.idUsuario = this._appService.UsuarioLogado.usuarioIDeCargo;

    this._grupoService.getGruposEconomicos(request).subscribe((m) => {
      this.grupos = m;

      if (this.grupos != null) {
        this.comboGrupoEconomico.options = [];
        this.grupos.forEach((grp) => {
          this.comboGrupoEconomico.options.push({
            id: grp.idGrupo,
            name: grp.descGrupo,
          });
        });
      } // em caso de erro (ex.: sessão expirada)
      else this.closeModal.nativeElement.click();
      this.loadingGrupos = false;
      setTimeout(() => {
        this.gruposSelecionados = this.getGrupoStorage();
      }, 10);
    });
  }

  ocultarMensagem() {
    this.mensagemErro = "";
  }

  aplicarGrupo() {
    var cnpjs = "";
    var label = "";
    var total = 0;
    if (this.gruposSelecionados) {
      this.gruposSelecionados.forEach((g) => {
        let grp: GrupoEconomico = this.grupos.find((f) => f.idGrupo == g) as GrupoEconomico;
        cnpjs += grp.listaCNPJCliente + ";";
        if (label == "") {
          label =
            grp.descGrupo.indexOf(" ") > 0
              ? ": " + grp.descGrupo.substring(0, grp.descGrupo.indexOf(" "))
              : ": " + grp.descGrupo;
        }
        total += 1;
      });
    }
    if (label && total > 1) label += " + " + (total - 1).toString();

    if (cnpjs) cnpjs = cnpjs.substring(0, cnpjs.length - 1);

    if (cnpjs.length > 4000) {
      this.mensagemErro =
        "Muitos CNPJs selecionados. Selecionar no máximo 255 CNPJs.";
      return;
    }

    this.labelGrupo = label;
    label = "";
    this._appService.setLocalStorage("labelGrupo", this.labelGrupo);
    this._appService.setLocalStorage("cnpjGrupos", cnpjs);
    this._appService.setLocalStorageJson(
      "idsGruposSelecionados",
      this.gruposSelecionados
    );
    this._grupoService.grupoEconomicoSelecionadoEvent.emit(cnpjs);
    this.closeModal.nativeElement.click();
  }

  cancelarGrupo() {
    this.gruposSelecionados = this.getGrupoStorage();
    this.closeModal.nativeElement.click();
  }

  getGrupoStorage(): any {
    return this._appService.getLocalStorageJson("idsGruposSelecionados");
  }

  navigateToVendorSite(event: Event): void {
    event.preventDefault(); // Prevent default anchor behavior
    const url = this._appService.configInfo.novoSiteVendor;

    if (url) {
      window.location.href = url; // Redirect to the specified URL
    } else {
      console.error("Vendor login URL is not defined");
    }
  }

  navigateToRegisterVendorSite(event: Event): void {
    event.preventDefault(); // Prevent default anchor behavior
    const url = this._appService.configInfo.novoSiteVendorRegistrar;

    if (url) {
      window.location.href = url; // Redirect to the specified URL
    } else {
      console.error("Vendor register URL is not defined");
    }
  }

  public redirectToRegisterForge(event?: Event): void {
    event?.preventDefault(); // Prevent default anchor behavior
    const url = this._appService.configInfo.clientRegisterUrl;

    if (url) {
      window.location.href = url; // Redirect to the specified URL
    } else {
      console.error("Client register URL is not defined");
    }
  }

  redirectToNovoSiteCotacao(event: Event): void {
    event.preventDefault(); // Prevent default anchor behavior
    const url = this._appService.configInfo.novoSiteCotacao;

    if (url) {
      window.location.href = url; // Redirect to the specified URL
    } else {
      console.error("Cotação register URL is not defined");
    }
  }

  hideCookiesConsent() {
    this.shouldShowCookiesConsent = false
  }
}
